import { AnalyticsComparisonMode } from '@shared/api/graphql/generated';

const PREVIOUS_PERIOD_LABELS = {
  /** Пояснение под графиком выручки. */
  chart: 'Сопоставление с равным предыдущим периодом.',
  /** Подпись дельты: «−12% <delta>». */
  delta: 'к прошлому периоду',
  /** Название окна сравнения: пилюля, тултип KPI и вариант в фильтре периода. */
  previous: 'Прошлый период',
};

const SAME_PERIOD_LAST_YEAR_LABELS = {
  chart: 'Сопоставление с теми же датами год назад.',
  delta: 'к прошлому году',
  previous: 'Год назад',
};

/** Подписи окна сравнения по режиму, который бэкенд вернул в `comparison.mode`. */
export const COMPARISON_MODE_LABELS = {
  [AnalyticsComparisonMode.PreviousMonthToDate]: PREVIOUS_PERIOD_LABELS,
  [AnalyticsComparisonMode.PreviousPeriod]: PREVIOUS_PERIOD_LABELS,
  [AnalyticsComparisonMode.SamePeriodLastYear]: SAME_PERIOD_LAST_YEAR_LABELS,
} satisfies Record<AnalyticsComparisonMode, typeof PREVIOUS_PERIOD_LABELS>;

/** Варианты базы сравнения в фильтре периода: значение URL-параметра `compare` и подпись. */
export const COMPARISON_OPTIONS = [
  { compare: undefined, label: PREVIOUS_PERIOD_LABELS.previous },
  { compare: 'year', label: SAME_PERIOD_LAST_YEAR_LABELS.previous },
] as const;
